import React from "react";
import {
    Box,
    Button,
    CheckBox,
    Form,
    FormGroup,
    SubmitButton,
    TextInput,
    Text,
    Stack,
} from "@unibuddy/patron";
import * as yup from "yup";

import {FormikHelpers} from "formik";
import {PRIVACY_POLICY} from "../../utils/constants";

type ConversationLeadProps = {
    handleSubmit: (email: string, ubConsent: boolean) => Promise<void>;
    handleDismiss: () => void;
};

type FormValues = {
    email: string;
    privacyChecked?: boolean;
};

export function ConversationLeadForm({handleSubmit, handleDismiss}: ConversationLeadProps) {
    return (
        <Form
            initialValues={{email: "", privacyChecked: false}}
            validationSchema={{
                email: yup.string().email().required(),
                privacyChecked: yup.boolean().required(),
            }}
            onSubmit={async (values: FormValues, {setSubmitting}: FormikHelpers<FormValues>) => {
                setSubmitting(true);
                try {
                    const ubConsent = values.privacyChecked ?? false;
                    if (!ubConsent) {
                        setSubmitting(false);
                        return;
                    }
                    await handleSubmit(values.email, ubConsent);
                } catch (error) {
                    console.error(error);
                    setSubmitting(false);
                }
            }}
        >
            {(props: {values: FormValues; isSubmitting: boolean}) => {
                const {values, isSubmitting} = props;
                return (
                    <Stack space="small">
                        <Box>
                            <Text align="center" weight="700">
                                {
                                    "Submit your email below so that we can follow up on your chat today"
                                }
                            </Text>
                        </Box>

                        <Box>
                            <FormGroup label="Email address" id="email">
                                <TextInput
                                    required
                                    type="email"
                                    name="email"
                                    autoComplete="email"
                                    value={values.email ?? ""}
                                />
                            </FormGroup>

                            <FormGroup id="privacypolicy">
                                <CheckBox id="privacy" name="privacyChecked">
                                    <Text size="small">
                                        {
                                            "By adding your email you are agreeing to Unibuddy's T&C's and privacy policy. "
                                        }
                                        <a
                                            href={PRIVACY_POLICY}
                                            rel="noreferrer noopener"
                                            target="_blank"
                                        >
                                            Read more
                                        </a>
                                        {" about how Unibuddy uses your data."}
                                    </Text>
                                </CheckBox>
                            </FormGroup>
                        </Box>

                        <Box gap="small" display="flex">
                            <Button
                                color="default"
                                ghost
                                block
                                size="sm"
                                onClick={handleDismiss}
                                disabled={isSubmitting}
                            >
                                Skip
                            </Button>
                            <SubmitButton
                                color="primary"
                                block
                                size="sm"
                                disabled={values.email === "" || !values.privacyChecked}
                            >
                                Submit
                            </SubmitButton>
                        </Box>
                    </Stack>
                );
            }}
        </Form>
    );
}
